import {deserialize} from '../serializers/multiCompanies';
import {CompaniesStore} from '../store/MultiCompanies';
import {saveSelectedCompanies} from '../services/multiCompanies';

export function getOptionsFromRawData(data) {
    return data?.General[0]?.MultiCompanies;
}

export function companiesFromData(data) {
    const options = getOptionsFromRawData(data);
    return new CompaniesStore(options);
}

export function saveSelected(companiesStore) {
    const selectedCompanies = companiesStore.selectedCompanies;
    const companiesJson = deserialize(selectedCompanies);
    saveSelectedCompanies(companiesJson);
}
